
  Vue.component('seeker-lists-new-modal', {
    data() {
      return {
        name: '',
        formInterfaces: {}
      }
    },
    pinia: Vue.pinia,
    template: '#seeker-lists-new-modal',
    computed: {
      ...Pinia.mapState(useModalsStore, ['newSeekerListModal']),
      formConfigListName() {
        return [
          {
            id: 0,
            fieldName: 'txtListName',
            label: `Nome della lista`,
            validators: [{ type: 'required' }]
          }
        ]
      }
    },
    watch: {},
    methods: {
      ...Pinia.mapActions(useModalsStore, ['closeNewSeekerListModal']),
      ...Pinia.mapActions(useSeekerListsStore, ['createNewList', 'addToList', 'refreshSeekerLists']),

      createNewListAndAddCurriculum() {
        const key = 'ListName'
        if (this.formInterfaces[key].validate()) {
          const field = { ...this.formInterfaces[key].getValues() }
          return this.createNewList(field.txtListName, 'Favourites')
            .then(list => {
              this.newSeekerListModal.curriculumId
                ? this.addToList(list.Id, this.newSeekerListModal.curriculumId)
                : this.refreshSeekerLists()
              return list
            })
            .then(list => EventBus.$emit('newListAdded', list))
            .then(() => this.closeNewSeekerListModal())
        }
      },
      getFormInterface(formInterface) {
        this.formInterfaces[formInterface.key] = formInterface
      }
    },
    mounted() {}
  })
